module.exports = __webpack_public_path__ + "img/data-server-1.2b8a45f.png";